import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import { AlertCircle, Home } from 'lucide-react';

const ErrorPage: React.FC = () => {
  const error = useRouteError();
  
  let errorMessage = 'An unexpected error occurred';
  let errorStatus = '500';
  
  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText || error.data?.message || errorMessage;
    errorStatus = error.status.toString();
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  }

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="text-center text-white max-w-md mx-auto p-8">
        <div className="flex justify-center mb-6">
          <AlertCircle size={64} className="text-red-500" />
        </div>
        
        <h1 className="text-4xl font-bold mb-4">
          {errorStatus === '404' ? 'Page Not Found' : 'Oops!'}
        </h1>
        
        <p className="text-gray-400 mb-6 text-lg">
          {errorMessage}
        </p>
        
        {errorStatus === '404' && (
          <p className="text-gray-500 mb-8">
            The page you're looking for doesn't exist.
          </p>
        )}
        
        <Link
          to="/dashboard"
          className="inline-flex items-center space-x-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <Home size={20} />
          <span>Go to Dashboard</span>
        </Link>
        
        <div className="mt-8 text-sm text-gray-500">
          <p>If this problem persists, please contact support.</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;